import React from 'react';
import { Backdrop, Portal } from '@mui/material';

import Loader from '@/components/Loader/Loader';

const BackdropLoader = () => (
  <Portal>
    <Backdrop
      open
      sx={{
        zIndex: theme => theme.zIndex.modal + 1,
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%'
      }}
    >
      <Loader />
    </Backdrop>
  </Portal>
);

export default BackdropLoader;
